const GsdIcon = () =>
{
      return (
            <svg
                  width={12}
                  height={12}
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
            >
                  <path
                        d="M1.64216 1.99841C1.21971 2.12146 0.891586 2.45778 0.782896 2.87613C0.754186 2.98687 0.750084 3.34165 0.750084 5.99942C0.750084 9.32779 0.741881 9.10016 0.887484 9.39136C0.98592 9.58823 1.20125 9.80356 1.39812 9.902C1.69343 10.0497 1.3284 10.0394 6 10.0394C10.6716 10.0394 10.3066 10.0497 10.6019 9.902C10.7988 9.80356 11.0141 9.58823 11.1125 9.39136C11.2581 9.10016 11.2499 9.32779 11.2499 5.99942C11.2499 2.67106 11.2581 2.89869 11.1125 2.60749C11.0141 2.41061 10.7988 2.19528 10.6019 2.09685C10.3066 1.94919 10.6737 1.95945 5.9877 1.9615C2.0277 1.9615 1.757 1.9656 1.64216 1.99841ZM10.2081 2.84742C10.2717 2.88434 10.325 2.93766 10.3619 3.00123L10.4194 3.09761V5.99942V8.90123L10.3619 8.99762C10.325 9.06119 10.2717 9.11451 10.2081 9.15142L10.1118 9.20885H6H1.88825L1.79186 9.15142C1.72829 9.11451 1.67497 9.06119 1.63806 8.99762L1.58064 8.90123V5.99942V3.09761L1.63601 3.00123C1.69753 2.89664 1.80417 2.82076 1.91696 2.7982C1.95797 2.79 3.818 2.7859 6.05127 2.78795L10.1118 2.79L10.2081 2.84742Z"
                        fill="currentColor"
                  />
                  <path
                        d="M7.51758 4.03079V4.44094H8.15331H8.78904V5.08692V5.73291H9.19919H9.60934V4.67677V3.62064H8.56346H7.51758V4.03079Z"
                        fill="currentColor"
                  />
                  <path
                        d="M2.39075 7.32228V8.37842H3.42638H4.462V7.96827V7.55812H3.83653H3.21105V6.91213V6.26615H2.8009H2.39075V7.32228Z"
                        fill="currentColor"
                  />
            </svg>

      )
}

export default GsdIcon